import { ORGANIZATION_TYPES } from './enums';
import { validateEmail } from './validate';
import { get } from 'lodash';

export const QUERY_SEARCH_STRING = 'QuerySearchString';
export const GOOGLE_ADS_CLICK_IDENTIFIERS = 'GoogleAdsCLickIdentifiers';
export const REFERRAL_CODE_STORAGE_KEY = 'ReferralCode';

export const validGoogleAdsParams = ['gclid', 'wbraid', 'gbraid'];

export const validateQuerySearchString = (key, value) => {
  if (!value || !key) return false;

  if (key === 'defaultEventSettingId') return ORGANIZATION_TYPES.some(({ name }) => name === value);

  if (key === 'email') return validateEmail(value);

  return true;
};

export const mapQuerySearchParams = {
  companyName: 'companyName',
  organizationType: 'defaultEventSettingId',
  orgType: 'orgType',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
};

export const loadGoogleAdsFromLocalStorage = () => {
  const searchData = JSON.parse(localStorage.getItem(GOOGLE_ADS_CLICK_IDENTIFIERS));
  if (!searchData || searchData?.oauthSearchParamsSet) return {};

  const result = {};

  const params = new URLSearchParams(searchData.searchParams);
  params.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      result[key] = value;
    }
  });

  localStorage.setItem(
    GOOGLE_ADS_CLICK_IDENTIFIERS,
    JSON.stringify({
      ...searchData,
      oauthSearchParamsSet: true,
    })
  );

  return result;
};

/**
 * Get the stored referral code from localStorage
 * This is more reliable than trying to find the right RH campaign from window object
 *
 * @returns {string|null} - The referral code (mwr parameter) or null
 */
export const getReferralCode = () => {
  return localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
};

/**
 * Store the referral code (mwr parameter) in localStorage
 *
 * @param {string} code - The referral code to store
 */
export const setReferralCode = code => {
  if (code) {
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, code);
  }
};

export const verifyGoogleAdsParams = (location = {}) => {
  const searchData = JSON.parse(localStorage.getItem(GOOGLE_ADS_CLICK_IDENTIFIERS));
  const locationSearch = get(location, 'search', '');

  if (!searchData && !locationSearch) return false;

  const params = new URLSearchParams(searchData?.searchParams);
  const locationParams = new URLSearchParams(locationSearch);

  let ga = false;
  params.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      ga = true;
    }
  });

  locationParams.forEach((value, key) => {
    if (validGoogleAdsParams.includes(key)) {
      ga = true;
    }
  });

  return ga;
};

export const FUNNEL_START_STORAGE_KEY = 'registrationFunnelStart';

export const getFunnelStart = () => localStorage.getItem(FUNNEL_START_STORAGE_KEY);

export const setFunnelStart = slug => {
  if (slug) localStorage.setItem(FUNNEL_START_STORAGE_KEY, slug);
};

export const clearFunnelStart = () => localStorage.removeItem(FUNNEL_START_STORAGE_KEY);

export const PENDING_BANK_ACCOUNT_STORAGE_KEY = 'PendingBankAccount';

// Last4 of a bank account awaiting Plaid micro-deposit verification. Captured
// from Plaid Link metadata at connect time — no Stripe source exists until the
// account is verified, so this is the only place the mask is available.
export const getPendingBankLast4 = userId => {
  try {
    const stored = JSON.parse(localStorage.getItem(PENDING_BANK_ACCOUNT_STORAGE_KEY));
    return stored && stored.userId === userId ? stored.last4 : null;
  } catch (e) {
    return null;
  }
};

export const setPendingBankLast4 = (userId, last4) => {
  if (userId && last4) {
    localStorage.setItem(PENDING_BANK_ACCOUNT_STORAGE_KEY, JSON.stringify({ userId, last4 }));
  }
};

export const clearPendingBankLast4 = () =>
  localStorage.removeItem(PENDING_BANK_ACCOUNT_STORAGE_KEY);

export const UTM_STORAGE_KEY = 'go4_utm';

const partnershipUtmParams = {
  'buying-sandlot': {
    utm_source: 'buyingsandlot',
    utm_medium: 'newsletter',
    utm_campaign: 'sandlot-partnership',
    utm_content: '',
    utm_term: '',
  },
  upsl: {
    utm_source: 'upsl',
    utm_medium: 'newsletter',
    utm_campaign: 'upsl-partnership',
    utm_content: '',
    utm_term: '',
  },
  default: {
    utm_source: '',
    utm_medium: '',
    utm_campaign: 'partnership',
    utm_content: '',
    utm_term: '',
  },
};

export function captureUtm(search, partnership) {
  const params = new URLSearchParams(search);
  const partnershipDefaultParams = partnershipUtmParams[partnership || 'default'];

  const utm = {
    source: params.get('utm_source') || partnershipDefaultParams['utm_source'],
    medium: params.get('utm_medium') || partnershipDefaultParams['utm_medium'],
    campaign: params.get('utm_campaign') || partnershipDefaultParams['utm_campaign'],
    content: params.get('utm_content') || partnershipDefaultParams['utm_content'],
    term: params.get('utm_term') || partnershipDefaultParams['utm_term'],
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    landed_at: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
  } catch (e) {}
  return utm;
}
